const ocimfStatus = [
    { label: 'Observations had been rectified', value: 'Observations had been rectified' },
    { label: 'Observations had not been rectified', value: 'Observations had not been rectified' }
];

export default ocimfStatus;
